import React from 'react';

import { Stack, Text, Group } from '@mantine/core';
import dayjs from 'dayjs';
import { StaffWithProfilePicture } from 'types/generated';

interface SelfBookingAppointmentHeaderProps {
  appointmentName: string;
  duration: number;
  locationName?: string;
  selectedCoach?: StaffWithProfilePicture | null;
  selectedDate?: Date | null;
}

const SelfBookingAppointmentHeader = ({
  appointmentName,
  duration,
  locationName,
  selectedCoach,
  selectedDate,
}: SelfBookingAppointmentHeaderProps): JSX.Element => {
  return (
    <Stack spacing={0}>
      <Text size='xl' weight={700} lineClamp={1}>
        {appointmentName}
      </Text>

      <Group spacing='md'>
        <Text size='lg' lineClamp={1}>
          {duration} Minutes
        </Text>

        {locationName && (
          <Text size='lg' lineClamp={1}>
            | {locationName}
          </Text>
        )}
      </Group>

      {selectedCoach && (
        <Text size='lg' lineClamp={1}>
          {selectedCoach.fullName}
        </Text>
      )}

      {selectedDate && (
        <Text size='lg' lineClamp={1}>
          {dayjs(selectedDate).format('dddd MMMM D, YYYY')}
        </Text>
      )}
    </Stack>
  );
};

export default SelfBookingAppointmentHeader;
